export const REGISTRATION_PROGRESS_START_PERCENT = 4;

export const REGISTRATION_ONBOARDING_SLIDES = [
  'welcome',
  'costs',
  'benefits',
] as const;

export type OnboardingSlideKey =
  (typeof REGISTRATION_ONBOARDING_SLIDES)[number];

export type RegistrationStep = {
  id:
    | 'welcome'
    | 'costs'
    | 'benefits'
    | 'email'
    | 'personal-data'
    | 'photo'
    | 'photo-review'
    | 'goal-intro'
    | 'goal-details'
    | 'value-intro'
    | 'value-input'
    | 'value-review'
    | 'congrats'
    | 'ready';
  onboardingSlide?: OnboardingSlideKey;
  route: string;
  routeAliases?: readonly string[];
  progressPercentOverride?: number;
  progressEtaTranslationKey?: string;
};

export const REGISTRATION_STEPS: readonly RegistrationStep[] = [
  {
    id: 'welcome',
    route: '/registration/onboarding',
    onboardingSlide: 'welcome',
  },
  { id: 'costs', route: '/registration/onboarding', onboardingSlide: 'costs' },
  {
    id: 'benefits',
    route: '/registration/onboarding',
    onboardingSlide: 'benefits',
  },
  { id: 'email', route: '/registration/email' },
  { id: 'personal-data', route: '/registration/personal-data' },
  { id: 'photo', route: '/registration/photo' },
  { id: 'photo-review', route: '/registration/photo/review' },
  { id: 'goal-intro', route: '/registration/goal' },
  { id: 'goal-details', route: '/registration/goal/details' },
  { id: 'value-intro', route: '/registration/value' },
  { id: 'value-input', route: '/registration/value/input' },
  { id: 'value-review', route: '/registration/value/review' },
  {
    id: 'congrats',
    route: '/registration/congrats',
    routeAliases: ['/registration/card'],
    progressPercentOverride: 100,
    progressEtaTranslationKey: 'registrationComplete.progressEta',
  },
  { id: 'ready', route: '/registration/ready' },
] as const;

export type RegistrationStepId = (typeof REGISTRATION_STEPS)[number]['id'];

// Keep only stable registration checkpoints here. Transient preview states like
// `photo-review` are intentionally excluded so skip/back navigation returns to
// `/registration/photo` instead of depending on ephemeral route state.
export const IMPLEMENTED_REGISTRATION_STEP_IDS: readonly RegistrationStepId[] =
  [
    'welcome',
    'costs',
    'benefits',
    'email',
    'personal-data',
    'photo',
    'goal-intro',
    'value-intro',
    'congrats',
  ] as const;
